import { render, staticRenderFns } from "./SummaryServiceDetails.vue?vue&type=template&id=536d7256&"
import script from "./SummaryServiceDetails.vue?vue&type=script&lang=js&"
export * from "./SummaryServiceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports